import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import seoConfig from '../../config/seo.config';

const SEO = () => {
  const location = useLocation();
  const path = location.pathname;

  // Get SEO data for current route, fallback to default if not found
  const seoData = seoConfig.routes[path] || seoConfig.default;

  useEffect(() => {
    // Her route değişiminde title ve description güncelle
    document.title = seoData.title;
  }, [location.pathname, seoData.title]);

  return (
    <Helmet>
      <title>{seoData.title}</title>
      <meta name="description" content={seoData.description} />
      
      <meta property="og:title" content={seoData.title} />
      <meta property="og:description" content={seoData.description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={window.location.href} />
      
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={seoData.title} />
      <meta name="twitter:description" content={seoData.description} />
      
      <link rel="canonical" href={window.location.href} />
    </Helmet>
  );
};

export default SEO;
